'use strict';var _dec,_dec2,_dec3,_dec4,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const ErrorMessages=require('../../../../../dist-es6/client/errorMessages');

const EmailErrorMessage='Please enter an email address.';
const PasswordErrorMessage='Please enter a password.';
const LoginErrorMessage=`Invalid email address and\npassword combination.`;
const ExpiredLinkErrorMessage='Password reset link is expired.';
const InvalidNewPasswordErrorMessage='Password must meet requirements.';


const TechnicalSupportEmailAddress='info@pulsarinformatics.com';
const TechnicalSupportPhoneNumber='877.791.0989';let

LoginModalController=(_dec=




















































































































































HandleUncaughtErrors(()=>ModalSubmissionResult.KeepOpen),_dec2=









































HandleUncaughtErrors(()=>ModalSubmissionResult.KeepOpen),_dec3=




















































































HandleUncaughtErrors(()=>ModalSubmissionResult.KeepOpen),_dec4=















HandleUncaughtErrors(()=>ModalSubmissionResult.KeepOpen),(_class=class LoginModalController extends BaseController{constructor($state,$modalInstance,elementService,userService,uncaughtErrorHandler,uiCommandFactory,reason,$timeout,socketService,$scope,redirectionService){super(uncaughtErrorHandler);this._$state=$state;this._userService=userService;this._$modalInstance=$modalInstance;this._reason=reason;this._rememberAfterDisconnect=!0;this._elementService=elementService;this._$timeout=$timeout;this._socketService=socketService;this._redirectionService=redirectionService;this.determineAuthMechanismCommand=uiCommandFactory.makeForModal($modalInstance,this._determineAuthMechanism.bind(this));this.loginCommand=uiCommandFactory.makeForModal($modalInstance,this._login.bind(this));this.requestPasswordResetCommand=uiCommandFactory.makeForModal($modalInstance,this._requestPasswordReset.bind(this));this.performPasswordResetCommand=uiCommandFactory.makeForModal($modalInstance,this._performPasswordReset.bind(this));this._buildStateClasses();this._newPasswordIsVisible=!0;this.showingFront=!0;if(this._onLoginPage){$scope.$watch('controller._$state.params',(newParams,oldParams)=>{if(this._onLoginPage&&!_.exists(newParams.passwordResetRequest)&&this._isValidState(newParams.state)){this._resetErrorMessages();this._flipTo(newParams.state)}},!0);if(_.exists(this._$state.params.passwordResetRequest)){this.frontState='perform-reset';this._promisedBeginResetResponse=this._socketService.sendAndWaitForResponse('BeginPasswordReset',{token:this._$state.params.passwordResetRequest});this._promisedBeginResetResponse.then(response=>this._checkForPasswordResetExpiration(response))}}this.frontState=this.frontState||(this._onLoginPage&&this._isValidState(this._$state.params.state)?this._$state.params.state:'login');this._makeUrlMatchCurrentState();this._resetErrorMessages();$timeout(()=>{this.ready=!0;$timeout(()=>{this._resetFocus()})})}_resetFocus(){let elementId;switch(this._currentState){case'login':elementId='#login-email';break;case'request-reset':elementId='#forgot-password-email';break;case'perform-reset':elementId='#new-password';break;}if(_.exists(elementId)){this._elementService.selectElement(elementId)[0].focus()}}get _onLoginPage(){return this._$state.current.name==='fdc.features.login'}_buildStateClasses(){this._states=['login','request-reset','check-mail','perform-reset'];this.classes={};for(let state of this._states){this.classes[state]=`{ front: controller.frontState === '${state}', back: controller.backState === '${state}', hidden: controller.frontState !== '${state}' && controller.backState !== '${state}' }`}}_isValidState(state){return _.includes(this._states,state)}_makeUrlMatchCurrentState(){if(!this._onLoginPage){return}this._$state.go('fdc.features.login',{state:this._currentState,passwordResetRequest:this._currentState==='perform-reset'?this._$state.params.passwordResetRequest:void 0,return_to:this._$state.params.return_to})}_checkForPasswordResetExpiration(response){if(SocketResponse.isHttpError(response,404)){this._flipTo('request-reset',()=>{this._generalErrorMessage=ExpiredLinkErrorMessage});return!1}return!0}get isGoingToHelpCenter(){return this._redirectionService.helpCenterRedirectIsPending}_resetErrorMessages(){this._emailErrorMessage=null;this._passwordErrorMessage=null;this._generalErrorMessage=null}get DefaultEmailErrorMessage(){return EmailErrorMessage}get DefaultPasswordErrorMessage(){return PasswordErrorMessage}get reason(){return this._reason}async _determineAuthMechanism(){this._resetErrorMessages();const params={email:this._email};const result=await this._socketService.sendAndWaitForResponse('DetermineAuthMechanism',params);if(!SocketResponse.succeeded(result)){return this._handleModalSubmissionErrorsAndGetModalResult(result,params)}const authMechanismResponse=result.body;if(!_.exists(authMechanismResponse.authenticationFrontend)||authMechanismResponse.authenticationFrontend==='redirect'&&!_.exists(authMechanismResponse.url)||authMechanismResponse.authenticationFrontend==='local'&&authMechanismResponse.email!==params.email.toLowerCase()){this._generalErrorMessage=ErrorMessages.InvalidAuthConfig;return ModalSubmissionResult.KeepOpen}this._authenticationFrontend=authMechanismResponse.authenticationFrontend;switch(authMechanismResponse.authenticationFrontend){case'redirect':this._$timeout(()=>{window.location=authMechanismResponse.url},500);break;case'local':this._$timeout(()=>{this._elementService.selectElement('form[name="loginForm"] input#password').focus()},100);break;default:this._generalErrorMessage=ErrorMessages.OopsTryAgain;throw new Error('Got unknown authenticationFrontend: '+authMechanismResponse.authenticationFrontend);}return ModalSubmissionResult.KeepOpen}async _login(){this._resetErrorMessages();const params={email:this._email,password:this._password,rememberAfterDisconnect:this._rememberAfterDisconnect};let result=await this._userService.beginUserSession(params);if(SocketResponse.succeeded(result)){return ModalSubmissionResult.Close()}return this._handleModalSubmissionErrorsAndGetModalResult(result,params)}_handleModalSubmissionErrorsAndGetModalResult(result,params){let errors=result.status==='HttpError'?_.get(result,'body.errors',[]):[];for(const error of errors){switch(error){case'instance requires property "email"':case'instance.email does not conform to the "email" format':case`invalid email address: ${params.email}`:this._emailErrorMessage=EmailErrorMessage;break;case'instance requires property "password"':case'instance.password does not meet minimum length of 1':this._passwordErrorMessage=PasswordErrorMessage;break;case'Invalid username and password combination.':this._generalErrorMessage=LoginErrorMessage;break;}}if(!_.exists(this._emailErrorMessage)&&!_.exists(this._passwordErrorMessage)&&!_.exists(this._generalErrorMessage)){this._generalErrorMessage=ErrorMessages.OopsTryAgain}return ModalSubmissionResult.KeepOpen}_resetAuthMechanismAndPassword(){this._$timeout(()=>{this._authenticationFrontend=null;this._password=''})}get _currentState(){return this.showingFront?this.frontState:this.backState}_flipTo(nextState,postFlipAction){if(!this._isValidState(nextState)){throw new Error('unexpected state')}this._$timeout(()=>{if(nextState===this._currentState){return}if(this.showingFront){this.backState=nextState}else{this.frontState=nextState}this._$timeout(()=>{this.showingFront=!this.showingFront;this._makeUrlMatchCurrentState();this._resetFocus();if(_.exists(postFlipAction)){this._$timeout(()=>postFlipAction())}})})}async _requestPasswordReset(){this._resetErrorMessages();let email=this.email;let result=await this._socketService.sendAndWaitForResponse('RequestPasswordReset',{email});if(SocketResponse.isHttpError(result,422)){this._emailErrorMessage=EmailErrorMessage}else{this._flipTo('check-mail')}return ModalSubmissionResult.KeepOpen}
async _performPasswordReset(){
this._resetErrorMessages();

if(_.exists(this._promisedBeginResetResponse)){
let beginResetResponse=await this._promisedBeginResetResponse;
if(!this._checkForPasswordResetExpiration(beginResetResponse)){
return ModalSubmissionResult.KeepOpen;
}

if(!SocketResponse.succeeded(beginResetResponse)){
this._generalErrorMessage=ErrorMessages.OopsTryAgain;
return ModalSubmissionResult.KeepOpen;
}
}

let finishResetResponse=await this._socketService.sendAndWaitForResponse('FinishPasswordReset',{
token:this._$state.params.passwordResetRequest,
newPassword:this.newPassword});


if(!this._checkForPasswordResetExpiration(finishResetResponse)){
return ModalSubmissionResult.KeepOpen;
}

if(SocketResponse.isHttpError(finishResetResponse,422)){
this._newPasswordErrorMessage=InvalidNewPasswordErrorMessage;
return ModalSubmissionResult.KeepOpen;
}else if(!SocketResponse.succeeded(finishResetResponse)){
this._generalErrorMessage=ErrorMessages.OopsTryAgain;
return ModalSubmissionResult.KeepOpen;
}

this._reason='PasswordChanged';
this._flipTo('login',()=>this.newPassword='');
return ModalSubmissionResult.KeepOpen;
}

get email(){
return this._email;
}
set email(email){
this._email=email;
}

get password(){
return this._password;
}

set password(password){
this._password=password;
}

get rememberAfterDisconnect(){
return this._rememberAfterDisconnect;
}

set rememberAfterDisconnect(rememberAfterDisconnect){
this._rememberAfterDisconnect=rememberAfterDisconnect;
}

get emailErrorMessage(){
return this._emailErrorMessage;
}

get passwordErrorMessage(){
return this._passwordErrorMessage;
}

get generalErrorMessage(){
return this._generalErrorMessage;
}

get newPasswordErrorMessage(){
return this._newPasswordErrorMessage;
}

get technicalSupportPhoneNumber(){
return TechnicalSupportPhoneNumber;
}

get technicalSupportEmailAddress(){
return TechnicalSupportEmailAddress;
}

forgotPassword(){
this._password='';
this._resetErrorMessages();
this._flipTo('request-reset');
}

backToSignIn(){
this._resetErrorMessages();
this._flipTo('login');
}

get newPassowrdIsVisible(){
return this._newPasswordIsVisible;
}

toggleNewPasswordVisibility(){
this._newPasswordIsVisible=!this._newPasswordIsVisible;
this._resetFocus();
}},(_applyDecoratedDescriptor(_class.prototype,'_determineAuthMechanism',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_determineAuthMechanism'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_login',[_dec2],Object.getOwnPropertyDescriptor(_class.prototype,'_login'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_requestPasswordReset',[_dec3],Object.getOwnPropertyDescriptor(_class.prototype,'_requestPasswordReset'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_performPasswordReset',[_dec4],Object.getOwnPropertyDescriptor(_class.prototype,'_performPasswordReset'),_class.prototype)),_class));


module.exports=LoginModalController;
//# sourceMappingURL=loginModalController.js.map
